module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGQ9Ik0zIDNoMTh2MThIM3oiLz4KICAgICAgICA8cGF0aCBzdHJva2U9IiNBMTlEOUMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTYgOC4yNWgxMk0xMC41IDExLjI1djQuNU0xMy41IDExLjI1djQuNU02Ljc1IDguMjVsLjc1IDlhMS41IDEuNSAwIDAgMCAxLjUgMS41aDZhMS41IDEuNSAwIDAgMCAxLjUtMS41bC43NS05TTkuNzUgOC4yNVY2YS43NS43NSAwIDAgMSAuNzUtLjc1aDNhLjc1Ljc1IDAgMCAxIC43NS43NXYyLjI1Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/trash2.svg
// module id = drVQ
// module chunks = 30